import { useQuery } from "@tanstack/react-query";
import fetchToBackend from "@/utils/fetchToBackend";
import { searchProfileKeys } from "@/lib/query-keys";
import type { SearchProfile } from "@/types/domain";

export function useSearchProfiles(enabled = true) {
  return useQuery({
    queryKey: searchProfileKeys.all,
    enabled,
    queryFn: async () => {
      const res = await fetchToBackend<any>("/searchprofiles");
      return (res?.data ?? res ?? []) as SearchProfile[];
    },
  });
}
